import { ScreenWidthBreakpoints } from '~src/model';

export const STATIC_SCREEN_BREAKPOINTS: ScreenWidthBreakpoints = {
  SMALL_MOBILE: 375,
  LARGE_MOBILE: 750,
  TABLET: 1140,
  LAPTOP: 1440,
  DESKTOP: 1920,
};
